import type { ReactNode } from 'react';
import type { Band } from '../types';

interface Props {
  band: Band;
  rank?: number | null;
  right?: ReactNode;
}

/** One band line: image, name, genres, optional rank badge and action slot. */
export function BandRow({ band, rank, right }: Props) {
  return (
    <div className={`band ${rank ? 'top' : ''}`}>
      {band.imageUrl ? <img src={band.imageUrl} alt="" loading="lazy" /> : <div className="band-img">♪</div>}
      <div className="name">
        <strong>{rank ? <span className="rank">#{rank}</span> : null} {band.name}</strong>
        <span className="muted small">{band.genres.slice(0, 3).join(' · ') || band.disambiguation || ''}</span>
      </div>
      {right}
    </div>
  );
}
